import VibeApi from './VibeApi'

export {
  VibeApi
}

export default VibeApi
